import {ErrorToast} from '@/components/VueToast';
import dropdownService from '../api/Dropdown';

export async function getUserDropdown(userDropdown) {
    try {
        const {data} = await dropdownService.getUsers();
        userDropdown.value = data.data.map(item => ({
            label: `${item.firstName}` + ' ' + `${item.lastName}`,
            value: item?.id,
            engagementType: item?.engagementType,
        }));
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getInternalCoordinatorDropdown(coordinatorDropdown) {
    try {
        const {data} = await dropdownService.getInternalCoordinator();
        coordinatorDropdown.value = data.data.map(item => ({
            label: `${item.firstName}` + ' ' + `${item.lastName}`,
            value: item?.id,
        }));
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getExternalCoordinatorDropdown(coordinatorDropdown) {
    try {
        const {data} = await dropdownService.getExternalCoordinator();
        coordinatorDropdown.value = data.data.map(item => ({
            label: `${item.firstName}` + ' ' + `${item.lastName}`,
            value: item?.id,
        }));
    } catch (error) {
        await ErrorToast(error);
    }
}


export async function getUserForLocationDropdown(userDropdown, locationId) {
    try {
        const {data} = await dropdownService.getUsersForLocation(locationId);
        userDropdown.value = data.data.map(item => ({
            label: `${item.firstName}` + ' ' + `${item.lastName}`,
            value: item?.id,
        }));
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getCoachDropdown(coachDropdown, filterData) {
    try {
        const {data} = await dropdownService.getCoach(filterData);
        coachDropdown.value = data.data.map(item => ({
            label: `${item.firstName}` + ' ' + `${item.lastName}`,
            value: item?.id,
        }));
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getSocioTherapistByLocationDropdown(socioTherapistDropdown, locationId) {
    try {
        const {data} = await dropdownService.getSocioTherapistByLocation(locationId);
        socioTherapistDropdown.value = data.data.map(item => ({
            label: `${item.firstName}` + ' ' + `${item.lastName}`,
            value: item?.id,
        }));
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getUsersForPrivateCoachingDropdown(userDropdown, locationId) {
    try {
        const {data} = await dropdownService.getUsersForPrivateCoaching(locationId);
        userDropdown.value = data.data.map(item => ({
            label: `${item.firstName}` + ' ' + `${item.lastName}`,
            value: item?.id,
        }));
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getUsersForAssistedLivingCoachingDropdown(userDropdown, locationId) {
    try {
        const {data} = await dropdownService.getUsersAssistedLivingCoaching(locationId);
        userDropdown.value = data.data.map(item => ({
            label: `${item.firstName}` + ' ' + `${item.lastName}`,
            value: item?.id,
        }));
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getUsersForCaseManagementCoachingDropdown(userDropdown, locationId) {
    try {
        const {data} = await dropdownService.getUsersCaseManagementCoaching(locationId);
        userDropdown.value = data.data.map(item => ({
            label: `${item.firstName}` + ' ' + `${item.lastName}`,
            value: item?.id,
        }));
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getUserLastNameDropdown(userDropdown) {
    try {
        const {data} = await dropdownService.getUsers();
        userDropdown.value = data.data.map(item => ({
            label: `${item.lastName}`,
            value: item.lastName,
        }));
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getUsersForHrOverviewDropdown(userDropdown) {
    try {
        const {data} = await dropdownService.getUsersForHrOverview();
        userDropdown.value = data.data.map(item => ({
            label: `${item.firstName}` + ' ' + `${item.lastName}`,
            value: item.id,
        }));
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getUsersForCoordinatorOverviewDropdown(userDropdown, includeHimSelf = 'false') {
    try {
        const {data} = await dropdownService.getUsersForCoordinatorOverview(includeHimSelf);
        userDropdown.value = data.data.map(item => ({
            label: `${item.firstName}` + ' ' + `${item.lastName}`,
            value: item.id,
        }));
    } catch (error) {
        await ErrorToast(error);
    }
}


export async function getExternalCoachDropdown(coachDropdown) {
    try {
        const {data} = await dropdownService.getExternalCoach();
        coachDropdown.value = data.data.map(item => ({
            label: `${item.firstName}` + ' ' + `${item.lastName}`,
            value: item.id,
        }));
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getExternalCoachForBillingDropdown(coachDropdown) {
    try {
        const {data} = await dropdownService.getExternalCoachForBilling();
        coachDropdown.value = data.data.map(item => ({
            label: `${item.firstName}` + ' ' + `${item.lastName}`,
            value: item.id,
        }));
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getExternalCoachForCoordinatorDropdown(coachDropdown) {
    try {
        const {data} = await dropdownService.getExternalCoachForCoordinator();
        coachDropdown.value = data.data.map(item => ({
            label: `${item.firstName}` + ' ' + `${item.lastName}`,
            value: item.id,
        }));
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getTravelExpensesUsersForCoordinator(userDropdown) {
    try {
        const {data} = await dropdownService.getTravelExpensesUsersForCoordinator();
        userDropdown.value = data.data.map(item => ({
            label: `${item.firstName}` + ' ' + `${item.lastName}`,
            value: item.id,
        }));
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getCoachDropdownForAnalytics(coachDropdown) {
    try {
        const {data} = await dropdownService.getCoachDropdownForAnalytics();
        coachDropdown.value = data.data.map(item => ({
            label: `${item.firstName}` + ' ' + `${item.lastName}`,
            value: item.id,
        }));
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getContactsForPotentialUnemployed(contactsDropdown) {
    try {
        const {data} = await dropdownService.getContactsForPotentialUnemployed();
        contactsDropdown.value = data.data.map(item => ({
            label: `${item.firstName}` + ' ' + `${item.lastName}`,
            value: item.id,
        }));
    } catch (error) {
        await ErrorToast(error);
    }
}

//--------------------------------------------------------------------------------------------

export async function getCoordinatorForOfficeAuditDropdown(coordinatorDropdown, locationId) {
    try {
        const {data} = await dropdownService.getCoordinatorForOfficeAudit(locationId);
        coordinatorDropdown.value = data.data.map(item => ({
            label: `${item.firstName}` + ' ' + `${item.lastName}`,
            value: item?.id,
        }));
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getOfficeDropdown(officeDropdown, translation = null, params = {}) {
    try {
        const {data} = await dropdownService.getOffices(params);

        if (translation) {
            officeDropdown.value = [{
                label: translation('placeholder.office_name'),
                value: null,
            }, ...data.data.map(item => ({
                label: `${item.name} `,
                value: item?.id,
            }))];
        } else {
            officeDropdown.value = data.data.map(item => ({
                label: `${item.name}`,
                value: item?.id,
            }));
        }
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getOfficeByUserRoleDropdown(officeDropdown, translation = null) {
    try {
        const {data} = await dropdownService.getOfficesByUserRole();

        if (translation) {
            officeDropdown.value = [{
                label: translation('placeholder.office_name'),
                value: null,
            }, ...data.data.map(item => ({
                label: `${item.name} `,
                value: item?.id,
            }))];
        } else {
            officeDropdown.value = data.data.map(item => ({
                label: `${item.name}`,
                value: item?.id,
            }));
        }
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getClientDropdown(clientDropdown, translation = null) {
    try {
        const {data} = await dropdownService.getClients();

        if (translation) {
            clientDropdown.value = [{
                label: translation('placeholder.client_name'),
                value: null,
            }, ...data.data.map(item => ({
                label: `${item.name} `,
                value: item?.id,
            }))];
        } else {
            clientDropdown.value = data.data.map(item => ({
                label: `${item.name}`,
                value: item?.id,
            }));
        }
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getClientByLocationDropdown(clientDropdown, locationId) {
    try {
        const {data} = await dropdownService.getClientsByLocation(locationId);

        clientDropdown.value = data.data.map(item => ({
            label: `${item.name}`,
            value: item?.id,
        }));
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getClientForCaseManagementDropdown(clientDropdown) {
    try {
        const {data} = await dropdownService.getClientsForCaseManagementCoaching();

        clientDropdown.value = data.data.map(item => ({
            label: `${item.name}`,
            value: item?.id,
        }));
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getProvinceDropdown(provinceDropdown) {
    try {
        const {data} = await dropdownService.getProvince();
        provinceDropdown.value = data.data.map(item => ({
            label: `${item.name}`,
            value: item?.id,
        }));
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getAllUnemployedDropdown(
    unemployedDropdown,
    label = 'lastName',
    value = 'id',
    filters = {}
) {
    try {
        const {data} = await dropdownService.getAllUnemployed(filters);

        const dropdownItems = [];
        for (const item of data.data) {
            if (item[label] && item[value]) {
                dropdownItems.push({label: item[label], value: item[value]});
            }
        }

        unemployedDropdown.value = dropdownItems;
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getNewAndActiveUnemployedDropdown(
    unemployedDropdown,
    label = 'lastName',
    value = 'id',
    filters = {}
) {
    try {
        const {data} = await dropdownService.getNewAndActiveUnemployed(filters);

        const dropdownItems = [];
        for (const item of data.data) {
            if (item[label] && item[value]) {
                dropdownItems.push({label: item[label], value: item[value]});
            }
        }

        unemployedDropdown.value = dropdownItems;
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getFinishedUnemployedDropdown(
    unemployedDropdown,
    label = 'lastName',
    value = 'id',
    filters = {}
) {
    try {
        const {data} = await dropdownService.getFinishedUnemployed(filters);

        const dropdownItems = [];
        for (const item of data.data) {
            if (item[label] && item[value]) {
                dropdownItems.push({label: item[label], value: item[value]});
            }
        }
        unemployedDropdown.value = dropdownItems;
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getPotentialUnemployedDropdown(potentialUnemployedDropdown, label = 'lastName', value = 'id') {
    try {
        const {data} = await dropdownService.getPotentialUnemployed();
        const dropdownItems = [];
        for (const item of data.data) {
            if (item[label] && item[value]) {
                dropdownItems.push({label: item[label], value: item[value]});
            }
        }
        potentialUnemployedDropdown.value = dropdownItems;
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getFinishedPrivateCoachingDropdown(coachingDropdown, label = 'unemployedLastName', value = 'unemployedLastName') {
    try {
        const {data} = await dropdownService.getFinishedPrivateCoaching();

        const dropdownItems = [];
        for (const item of data.data) {
            if (item[label] && item[value]) {
                dropdownItems.push({label: item[label], value: item[value]});
            }
        }

        coachingDropdown.value = dropdownItems;
    } catch (error) {
        await ErrorToast(error);
    }
}


export async function getArchivedPrivateCoachingDropdown(
    coachingDropdown,
    label = 'unemployedLastName',
    value = 'unemployedLastName',
    filters = {}
) {
    try {
        const {data} = await dropdownService.getArchivedPrivateCoaching(filters);

        const dropdownItems = [];
        for (const item of data.data) {
            if (item[label] && item[value]) {
                dropdownItems.push({label: item[label], value: item[value]});
            }
        }

        coachingDropdown.value = dropdownItems;
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getFinishedCaseManagementCoachingDropdown(coachingDropdown, label = 'unemployedLastName', value = 'unemployedLastName') {
    try {
        const {data} = await dropdownService.getFinishedCaseManagementCoaching();

        const dropdownItems = [];
        for (const item of data.data) {
            if (item[label] && item[value]) {
                dropdownItems.push({label: item[label], value: item[value]});
            }
        }

        coachingDropdown.value = dropdownItems;
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getArchivedCaseManagementCoachingDropdown(coachingDropdown, label = 'unemployedLastName', value = 'unemployedLastName') {
    try {
        const {data} = await dropdownService.getArchivedCaseManagementCoaching();

        const dropdownItems = [];
        for (const item of data.data) {
            if (item[label] && item[value]) {
                dropdownItems.push({label: item[label], value: item[value]});
            }
        }

        coachingDropdown.value = dropdownItems;
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getFinishedAssistedLivingCoachingDropdown(coachingDropdown, label = 'unemployedLastName', value = 'unemployedLastName') {
    try {
        const {data} = await dropdownService.getFinishedAssistedLivingCoaching();

        const dropdownItems = [];
        for (const item of data.data) {
            if (item[label] && item[value]) {
                dropdownItems.push({label: item[label], value: item[value]});
            }
        }

        coachingDropdown.value = dropdownItems;
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getArchivedAssistedLivingCoachingDropdown(coachingDropdown, label = 'unemployedLastName', value = 'unemployedLastName') {
    try {
        const {data} = await dropdownService.getArchivedAssistedLivingCoaching();

        const dropdownItems = [];
        for (const item of data.data) {
            if (item[label] && item[value]) {
                dropdownItems.push({label: item[label], value: item[value]});
            }
        }

        coachingDropdown.value = dropdownItems;
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getFinishedGroupCoachingDropdown(coachingDropdown, label = 'unemployedLastName', value = 'unemployedLastName') {
    try {
        const {data} = await dropdownService.getFinishedGroupCoaching();

        const dropdownItems = [];
        for (const item of data.data) {
            if (item[label] && item[value]) {
                dropdownItems.push({label: item[label], value: item[value]});
            }
        }

        coachingDropdown.value = dropdownItems;
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getArchivedGroupCoachingDropdown(coachingDropdown, label = 'unemployedLastName', value = 'unemployedLastName') {
    try {
        const {data} = await dropdownService.getArchivedGroupCoaching();

        const dropdownItems = [];
        for (const item of data.data) {
            if (item[label] && item[value]) {
                dropdownItems.push({label: item[label], value: item[value]});
            }
        }

        coachingDropdown.value = dropdownItems;
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getFinishedPrivateLearningCoachingDropdown(coachingDropdown, label = 'unemployedLastName', value = 'unemployedLastName') {
    try {
        const {data} = await dropdownService.getFinishedPrivateLearningCoaching();

        const dropdownItems = [];
        for (const item of data.data) {
            if (item[label] && item[value]) {
                dropdownItems.push({label: item[label], value: item[value]});
            }
        }

        coachingDropdown.value = dropdownItems;
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getArchivedPrivateLearningCoachingDropdown(coachingDropdown, label = 'unemployedLastName', value = 'unemployedLastName') {
    try {
        const {data} = await dropdownService.getArchivedPrivateLearningCoaching();

        const dropdownItems = [];
        for (const item of data.data) {
            if (item[label] && item[value]) {
                dropdownItems.push({label: item[label], value: item[value]});
            }
        }

        coachingDropdown.value = dropdownItems;
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getFinishedSocioTherapyCoachingDropdown(coachingDropdown, label = 'unemployedLastName', value = 'unemployedLastName') {
    try {
        const {data} = await dropdownService.getFinishedSocioTherapyCoaching();

        const dropdownItems = [];
        for (const item of data.data) {
            if (item[label] && item[value]) {
                dropdownItems.push({label: item[label], value: item[value]});
            }
        }

        coachingDropdown.value = dropdownItems;
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getArchivedSocioTherapyCoachingDropdown(coachingDropdown, label = 'unemployedLastName', value = 'unemployedLastName') {
    try {
        const {data} = await dropdownService.getArchivedSocioTherapyCoaching();

        const dropdownItems = [];
        for (const item of data.data) {
            if (item[label] && item[value]) {
                dropdownItems.push({label: item[label], value: item[value]});
            }
        }

        coachingDropdown.value = dropdownItems;
    } catch (error) {
        await ErrorToast(error);
    }
}


export async function getYears(dropdown) {
    try {
        const {data} = await dropdownService.getYear();

        dropdown.value = Object.entries(data.data).map(([key, value]) => ({
            label: key,
            value: value,
        }));

    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getCoachingTypes(dropdown, valuesToExclude) {
    try {
        const {data} = await dropdownService.getCoachingType();

        dropdown.value = Object.entries(data.data).map(([key, value]) => ({
            label: value,
            value: key,
        })).filter(item => !valuesToExclude?.includes(item.value));

    } catch (error) {
        await ErrorToast(error);
    }
}


export async function getPrivateCoachingDigitalDocumentsDropdown(documentsDropdown, unemployedId) {
    try {
        const {data} = await dropdownService.getPrivateCoachingDigitalDocuments(unemployedId);
        documentsDropdown.value = data.data.map(item => ({
            label: item.label,
            value: item.value,
        }));
    } catch (error) {
        await ErrorToast(error);
    }
}


export async function getPrivateCoachingByUnemployedDropdown(coachingDropdown, unemployedId) {
    try {
        const {data} = await dropdownService.getPrivateCoachingByUnemployed(unemployedId);
        coachingDropdown.value = data.data.map(item => ({
            label: item.label,
            value: item.id,
        }));
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getExcludedStatusValues(value, dropdown, valuesToExclude) {
    try {
        const {data} = await dropdownService.getCoachingType();

        dropdown.value = Object.entries(data.data).map(([key, value]) => ({
            label: value,
            value: key,
        })).filter(item => !valuesToExclude?.includes(item.value));

    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getCoursePrivateCoachingDropdown(
    coursePrivateCoachingDropdown,
    label = 'nameOfCoaching',
    value = 'id',
    locationId = null,
) {
    try {
        const queryParams = locationId ? locationId : '';

        const {data} = await dropdownService.getCoursePrivateCoaching(queryParams);
        const dropdownItems = [];
        for (const item of data.data) {
            if (item[label] && item[value]) {
                dropdownItems.push({label: item[label], value: item[value]});
            }
        }

        coursePrivateCoachingDropdown.value = dropdownItems;
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getCourseGroupCoachingDropdown(
    courseGroupCoachingDropdown,
    label = 'nameOfCoaching',
    value = 'id',
    locationId = null,
) {
    try {
        const queryParams = locationId ? locationId : '';

        const {data} = await dropdownService.getCourseGroupCoaching(queryParams);
        const dropdownItems = [];
        for (const item of data.data) {
            if (item[label] && item[value]) {
                dropdownItems.push({label: item[label], value: item[value], actionNumber: item.actionNumber});
            }
        }

        courseGroupCoachingDropdown.value = dropdownItems;
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getAddressBookDoctorDropdown(doctorDropdown, label = 'doctorNumber', value = 'id') {
    try {
        const {data} = await dropdownService.getAddressBookDoctor();
        const dropdownItems = [];
        for (const item of data.data) {
            if (item[label] && item[value]) {
                dropdownItems.push({label: item[label], value: item[value]});
            }
        }
        doctorDropdown.value = dropdownItems;
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getCoursePrivateLearningCoachingDropdown(
    dropdown,
    label = 'name',
    value = 'id',
    locationId = null,
) {
    try {
        const queryParams = locationId ? locationId : '';

        const {data} = await dropdownService.getCoursePrivateLearningCoaching(queryParams);
        const dropdownItems = [];
        for (const item of data.data) {
            if (item[label] && item[value]) {
                dropdownItems.push({label: item[label], value: item[value]});
            }
        }

        dropdown.value = dropdownItems;
    } catch (error) {
        await ErrorToast(error);
    }
}


// ENUMS FROM VUEX
export async function getPrivateCoachingOperationTypeDropdown(getEnums, operationTypeDropdown, keys = null) {
    const operationTypes = getEnums?.value?.privateCoachingOperationTypes || [];

    // Filter operationTypes based on the key parameter
    const filteredOperationTypes = keys
        ? operationTypes.filter(item => keys.includes(item?.key))
        : operationTypes;

    operationTypeDropdown.value = filteredOperationTypes.map(item => ({
        label: `${item.value} `,
        value: item?.key,
    }));
}

export function getWorkingDayDefinitionDropdown(getEnums, workingDayDefinitionDropdown) {
    const workingDayDefinition = getEnums?.enums?.workingDayDefinition || [];
    workingDayDefinitionDropdown.value = workingDayDefinition.map(item => ({
        label: `${item.value} `,
        value: item?.key,
    }));
}

export const getMonthsNumberDropdown = [
    {label: 1, value: 1},
    {label: 2, value: 2},
    {label: 3, value: 3},
    {label: 4, value: 4},
    {label: 5, value: 5},
    {label: 6, value: 6},
    {label: 7, value: 7},
    {label: 8, value: 8},
    {label: 9, value: 9},
    {label: 10, value: 10},
    {label: 11, value: 11},
    {label: 12, value: 12},
];

export function digitalSignatureNoteDropdown(
    forPrivateCoaching = false,
    k16 = false
) {
    const options = [
        {
            label: 'Abrechnung ohne Unterschrift lt. Sachbearbeiter genehmigt',
            value: 'Abrechnung ohne Unterschrift lt. Sachbearbeiter genehmigt'
        },
        {
            label: 'Unterschrift auf separater Liste, siehe anbei',
            value: 'Unterschrift auf separater Liste, siehe anbei'
        },
    ];

    if (forPrivateCoaching) {
        options.push(
            { label: 'Hausbesuch', value: 'Hausbesuch' },
            { label: 'Aufsuchend', value: 'Aufsuchend' }
        );

        if (!k16) {
            options.push({ label: 'Online', value: 'Online' });
        }
    } else {
        options.push({ label: 'Online', value: 'Online' });
    }

    return options;
}


export function assistedLivingCoachingClassificationDropdown() {
    return [
        {
            value: 'psyche',
            label: 'Psyche',
        },
        {
            value: 'seeks',
            label: 'Sucht',
        },
    ];
}


